var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-item"},[_c('div',{staticClass:"contact-item_name"},[_vm._v(_vm._s(_vm.item.name))]),_c('div',{staticClass:"contact-item_phone"},[_vm._v(_vm._s(_vm.item.phone))]),_c('div',{staticClass:"contact-item_email"},[_vm._v(_vm._s(_vm.item.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }